// Single source of truth for contact info & WhatsApp links.
export const PHONE_NUMBER_DISPLAY = "+91 93701 90995";
export const PHONE_NUMBER_TEL = "+919370190995";
export const WHATSAPP_NUMBER = "919370190995";

export const DEFAULT_WA_MESSAGE =
    "Hi, I need a crane service. Please share details.";

export function buildWhatsAppLink(message = DEFAULT_WA_MESSAGE) {
    const encoded = encodeURIComponent(message);
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
}

export const SERVICE_AREAS = [
    "Mumbai",
    "Thane",
    "Bhiwandi",
    "Wada",
    "Navi Mumbai",
];
